import type {
	GridCustomCellProps,
	GridItemChangeEvent,
} from "@tql/ui-components-react/kendo/grid";
import { useMemo } from "react";

import type { RoutingGuideEnumsType } from "~/shared/schemas/routing-guide-schema.ts";

import { CarrierFieldSelectorCell } from "../../grid/cells/carrier-field-selector-cell/index.tsx";
import { CarrierRuleActionsCell } from "../../grid/cells/carrier-rule-actions-cell/index.tsx";
import { FieldTextCell } from "../../grid/cells/field-text-cell/index.tsx";
import { OperatorCell } from "../../grid/cells/operator-cell/index.tsx";
import type { CarrierRule, RowUpdate } from "../utils/types.ts";

export const useCarrierColumns = (
	handleCarrierRowChange: (
		event: GridItemChangeEvent | RowUpdate<CarrierRule>,
	) => void,
	handleRemoveRow: (id: number) => void,
	showActivationErrors = false,
	routingGuideEnums?: RoutingGuideEnumsType,
) => {
	return useMemo(
		() => [
			{
				field: "fieldSelector",
				title: "Field Selector",
				menu: false,
				show: true,
				sortable: false,
				cells: {
					data: (props: GridCustomCellProps) => (
						<CarrierFieldSelectorCell
							cellTestId={"routing-guide-carrier-cell-field-selector"}
							handleCarrierRowChange={handleCarrierRowChange}
							routingGuideEnums={routingGuideEnums}
							showActivationError={showActivationErrors}
							{...props}
						/>
					),
				},
			},
			{
				field: "operator",
				title: "Operator",
				menu: false,
				show: true,
				sortable: false,
				cells: {
					data: (props: GridCustomCellProps) => (
						<OperatorCell<CarrierRule>
							cellTestId={"routing-guide-carrier-cell-operator"}
							handleRowChange={handleCarrierRowChange}
							isReadOnly={false}
							routingGuideEnums={routingGuideEnums}
							showActivationError={showActivationErrors}
							{...props}
						/>
					),
				},
			},
			{
				field: "field1",
				title: "Field 1",
				menu: false,
				show: true,
				sortable: false,
				cells: {
					data: (props: GridCustomCellProps) => (
						<FieldTextCell<CarrierRule>
							cellTestId={"routing-guide-carrier-cell-field-1"}
							fieldNum={0}
							handleRowChange={handleCarrierRowChange}
							isReadOnly={false}
							routingGuideEnums={routingGuideEnums}
							showActivationError={showActivationErrors}
							{...props}
						/>
					),
				},
			},
			{
				field: "",
				title: "Actions",
				menu: false,
				show: true,
				sortable: false,
				cells: {
					data: (props: GridCustomCellProps) => (
						<CarrierRuleActionsCell
							cellTestId={"routing-guide-carrier-cell-actions"}
							handleRemoveRow={handleRemoveRow}
							{...props}
						/>
					),
				},
			},
		],
		[
			handleCarrierRowChange,
			handleRemoveRow,
			routingGuideEnums,
			showActivationErrors,
		],
	);
};
